export enum ApibaseDeductibleExcessTypeCodeEnum {
    RepairAtNework = 'HSNW',
    Standard = 'STND',
    HN50 = 'HN50',
    Theft = 'DIEF',
    TotalLoss = 'TOTL',
    ReplaceAtNetwork = 'VVNW',
    ReplaceAtOwnChoice = 'VVEH',
}
